module.exports = __webpack_public_path__ + "img/fullProcessCoverage.f5fcccde.svg";